import suburbsCentroids from '@/scripts/suburbs-centroids.geojson.json';
import { GeocodeLocalDataSource } from './datasource';
import { LocalGeocodingResponseFeature, LocalGeocodingResponseModel } from '@/features';

export class SuburbsGeocodingLocalDatasource implements GeocodeLocalDataSource {
  getForwardGeocoding(searchTerm: string): LocalGeocodingResponseModel {
    const normalizedSearchTerm = searchTerm.toLowerCase().trim();

    const filteredSuburbs = suburbsCentroids.features.filter((feature) => {
      const suburbName = feature.name.toLowerCase();
      return suburbName.includes(normalizedSearchTerm);
    });

    return {
      features: filteredSuburbs,
    };
  }

  getGeocodingById(id: number): LocalGeocodingResponseFeature {
    const filteredSuburbs = suburbsCentroids.features.filter((feature) => feature.boundary_id == id);
    return filteredSuburbs[0] ?? [];
  }
}
